import * as tslib_1 from "tslib";
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { validatorsFor } from './asset-validators';
import { generatePayloadFrom, getValueFor, newRobotAssetFor, } from './asset-values';
var RobotAssetSource = /** @class */ (function () {
    function RobotAssetSource(_cache) {
        if (_cache === void 0) { _cache = []; }
        this._cache = _cache;
        this.source$ = new BehaviorSubject([]);
        this._increment = 0;
        this._emit();
    }
    Object.defineProperty(RobotAssetSource.prototype, "values", {
        get: function () {
            return this._cache;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotAssetSource.prototype, "length", {
        get: function () {
            return this.values.length;
        },
        enumerable: true,
        configurable: true
    });
    RobotAssetSource.prototype.updateType = function (type) {
        var _this = this;
        this.values.forEach(function (asset, idx) { return _this.values[idx] = newRobotAssetFor(type, asset); });
        this._emit();
    };
    RobotAssetSource.prototype.updateCredentialStore = function (credentialStoreId) {
        var _this = this;
        this.values.forEach(function (asset, idx) {
            _this.values[idx] = newRobotAssetFor(asset.type, asset);
            _this.values[idx].credentialStoreId = credentialStoreId;
        });
        this._emit();
    };
    RobotAssetSource.prototype.find = function (entity) {
        if (!entity) {
            return entity;
        }
        return this.values.find(function (e) { return e.id === entity.id; });
    };
    RobotAssetSource.prototype.persist = function (modified, type, value, readonly) {
        var robotAsset = tslib_1.__assign({}, generatePayloadFrom(modified, type, value, readonly), { robotName: modified.robotName, id: modified.id === -1 ? (Number.MIN_SAFE_INTEGER + ++this._increment) : modified.id });
        var index = this.values.findIndex(function (r) { return r.id === modified.id; });
        this.values[index] = robotAsset;
        this._emit();
    };
    RobotAssetSource.prototype.generateEntry = function (type, credentialStoreId) {
        var newAsset = newRobotAssetFor(type, {}, credentialStoreId);
        this.values.unshift(newAsset);
        return this.find(newAsset);
    };
    RobotAssetSource.prototype.isAssetBoundToRobot = function (id) {
        return this.values.filter(function (v) { return v.robotId === id; }).length > 1;
    };
    RobotAssetSource.prototype.remove = function (entry) {
        this.values.splice(this.values.findIndex(function (e) { return e.id === entry.id; }), 1);
        this._emit();
    };
    RobotAssetSource.prototype.isCollectionValid = function (type, readonly) {
        return this.values
            .reduce(function (prev, asset) {
            var validators = validatorsFor(type, asset.id < 0, readonly, true);
            var dataModel = getValueFor(asset, readonly);
            return prev && validators({
                value: dataModel,
            }) == null;
        }, true);
    };
    RobotAssetSource.prototype.destroy = function () {
        this.source$.complete();
    };
    RobotAssetSource.prototype.update = function () {
        this._emit();
    };
    RobotAssetSource.prototype._emit = function () {
        this.source$.next(cloneDeep(this.values));
    };
    return RobotAssetSource;
}());
export { RobotAssetSource };
